<template>
  <div class="document-tabs">
    <DocumentTab
      v-for="document in documents"
      v-bind:key="document.id"
      v-bind:document="document"
      v-on:document-click="$emit('document-click', document.id)"
      class="document-tab"
      :class="{ active: document.id === activeId }"
    />
  </div>
</template>

<script>
import DocumentTab from './DocumentTab.vue'

export default {
  name: 'DocumentTabs',
  components: {
    DocumentTab
  },
  props: ['documents', 'activeId']
}
</script>

<style lang='less' scoped>
.document-tabs {
  display: flex;
  flex-flow: column;
}
.document-tab {
  border-top: 1px solid var(--grey-240);

  &:last-of-type {
    border-bottom: 1px solid var(--grey-240);
  }

  &:hover,
  &.active {
    background: var(--grey-250);
  }
}
</style>
